'use client';

/** @app — application layer; owned per-fork (LMS / OTT). See PLATFORM_FILES.md. */
import { useTranslation } from 'react-i18next';
import { PortalLink } from '@akademi/site-builder-runtime';
import { Card } from '@akademi/ui';

interface PreviewVideoCardProps {
  /** Poster image URL. Falls back to a gradient if absent. */
  posterUrl?: string;
  /** Where clicking the preview takes the user. Typically the first
   *  lesson's play page. */
  href?: string;
  /** Optional label shown in the corner. Defaults to the catalogue's
   *  "preview" wording. */
  label?: string;
}

export function PreviewVideoCard({ posterUrl, href, label }: PreviewVideoCardProps) {
  const { t } = useTranslation('site-builder-blocks');
  const cornerLabel = label ?? t('courseDetail.preview.label');
  const inner = (
    <>
      {posterUrl ? (
        <img src={posterUrl} alt="" loading="lazy" decoding="async" width={320} height={180} />
      ) : (
        <div className="cd-preview-poster" aria-hidden>
          <span style={{ fontSize: 'var(--font-size-5xl, 60px)', opacity: 0.3 }}>▶</span>
        </div>
      )}
      <div className="cd-preview-play" aria-hidden>
        ▶
      </div>
      {cornerLabel && <div className="cd-preview-label">{cornerLabel}</div>}
    </>
  );
  if (href) {
    return (
      <Card asChild>
        <PortalLink href={href} className="cd-preview" aria-label={cornerLabel}>
          {inner}
        </PortalLink>
      </Card>
    );
  }
  return (
    <Card asChild>
      <div className="cd-preview">{inner}</div>
    </Card>
  );
}
